export default __webpack_public_path__ + "static/media/fire2.5da3b0da.svg";